<template>
  <div @click="callback" class="profile-card">
    <div class="profile-card__content">
      <span v-if="title" class="profile-card__title">{{ title }}</span>
      <span v-if="subtitle" class="profile-card__subtitle">{{ subtitle }}</span>
      <span v-if="email" class="profile-card__subtitle">{{ email }}</span>
      <span v-if="phone" class="profile-card__subtitle">{{ phone }}</span>
    </div>
    <div class="profile-card__circle">
      <IconComponent v-if="icon" :name="icon" />
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import ImgComponent from "components/ImgComponent.vue";
import SettingsModal from "components/modal/components/SettingsModal.vue";

export default {
  name: "ProfileCardComponent",
  props: {
    src: String,
    title: String,
    subtitle: String,
    phone: String,
    email: String,
    icon: String,
    route: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    callback() {
      if (this.route) {
        this.$router.push(JSON.parse(JSON.stringify(this.route)));
      } else {
        this.$store.state._modals.push({
          component: SettingsModal,
        });
      }
    },
  },
  components: {
    ImgComponent,
    IconComponent,
  },
};
</script>

<style lang="stylus">
.profile-card {
  position relative
  overflow hidden
  padding 45px
  border-radius 20px 20px 0 20px
  background var(--white)
  cursor pointer

  &:first-child {
    display flex
    align-items center
    gap 50px
    padding 35px
    grid-column span 2
    +below(750px) {
      grid-column auto
    }
    +below(600px) {
      flex-direction column
      gap 30px
      text-align center
    }
  }

  &__image {
    max-width 130px
    max-height 130px
    border-radius 50%
  }

  &__content {
    display flex
    flex-direction column
    gap 15px
  }

  &__title {
    font-size 1.5rem
    font-weight 600
    line-height 28px
    text-transform uppercase
    +below(600px) {
      font-size 1.25rem
      line-height 24px
    }
  }

  &__subtitle {
    font-size 1.25rem
    line-height 24px
    color var(--dark-2)
    +below(600px) {
      font-size 1rem
      line-height 20px
    }
  }

  &__circle {
    position absolute
    right 0
    bottom 0
    width 160px
    height 160px
    padding 67px
    border-radius 50%
    transform translate(28%, 28%)
    background var(--yellow-2)
    +below(600px) {
      width 140px
      height 140px
      transform translate(30%, 30%)
      padding 50px
    }

    .icon svg {
      max-width 26px
      max-height 24px

      path {
        fill var(--gray-8)
      }
    }
  }
}
</style>
